export const getDebouncer = (timeout = 0) => {
  let id: ReturnType<typeof setTimeout> | null;

  return (fn: () => void) => {
    if (id) {
      clearTimeout(id);
    }

    id = setTimeout(() => {
      fn();
      id = null;
    }, timeout);
  };
};
